// step 4 of the sponsor pledge flow

import React from 'react'
import Icon from '../../../../components/icon'

export default function Step4Marketing({
  styles,
  t,
  logoFile,
  bannerFile,
  onLogo,
  onBanner,
  removeLogo,
  removeBanner,
  brandMessage,
  setBrandMessage,
  orgMessage,
  setOrgMessage,
  validateStep4,
  setStep,
}) {
  return (
    <>
      <h1 className={styles.stepHeading}>
        {t('sponsorPledgeFlow.step4.heading')}
      </h1>
      <p className={styles.stepSubheading}>
        {t('sponsorPledgeFlow.step4.subheading')}
      </p>
      <p className={styles.stepSubheading} style={{ fontSize: 14 }}>
        {t('sponsorPledgeFlow.step4.assetsPinnedNote')}
      </p>
      <div className={styles.sectionLabel}>
        {t('sponsorPledgeFlow.step4.assetsSection')}
      </div>
      <div className={styles.inputRow}>
        <div>
          <label className={styles.crLabel}>
            {t('sponsorPledgeFlow.step4.logo')}
            <span className={styles.optionalTag}>
              {t('sponsorPledgeFlow.optional')}
            </span>
          </label>
          <div
            style={{ fontSize: 12, color: 'var(--light)', marginBottom: 10 }}
          >
            {t('sponsorPledgeFlow.step4.logoHint')}
          </div>
          <label className={styles.uploadZone}>
            <Icon name="camera" className={styles.uploadZoneIcon} />
            <span className={styles.uploadZoneLabel}>
              {t('sponsorPledgeFlow.step4.uploadLogo')}
            </span>
            <span className={styles.uploadZoneSub}>
              {t('sponsorPledgeFlow.step4.dropHint')}
            </span>
            <input
              type="file"
              accept="image/png,image/svg+xml"
              hidden
              onChange={onLogo}
            />
          </label>
          {logoFile ? (
            <div
              className={`${styles.uploadPreview} ${styles.uploadPreviewShow}`}
            >
              <Icon name="check" className={styles.uploadPreviewCheck} />
              <span className={styles.uploadPreviewName}>{logoFile.name}</span>
              <button
                type="button"
                className={styles.uploadRemove}
                onClick={removeLogo}
              >
                ×
              </button>
            </div>
          ) : null}
        </div>
        <div>
          <label className={styles.crLabel}>
            {t('sponsorPledgeFlow.step4.banner')}
            <span className={styles.optionalTag}>
              {t('sponsorPledgeFlow.optional')}
            </span>
          </label>
          <div
            style={{ fontSize: 12, color: 'var(--light)', marginBottom: 10 }}
          >
            {t('sponsorPledgeFlow.step4.bannerHint')}
          </div>
          <label className={styles.uploadZone}>
            <Icon name="camera" className={styles.uploadZoneIcon} />
            <span className={styles.uploadZoneLabel}>
              {t('sponsorPledgeFlow.step4.uploadBanner')}
            </span>
            <span className={styles.uploadZoneSub}>1140 × 300</span>
            <input
              type="file"
              accept="image/jpeg,image/png"
              hidden
              onChange={onBanner}
            />
          </label>
          {bannerFile ? (
            <div
              className={`${styles.uploadPreview} ${styles.uploadPreviewShow}`}
            >
              <Icon name="check" className={styles.uploadPreviewCheck} />
              <span className={styles.uploadPreviewName}>
                {bannerFile.name}
              </span>
              <button
                type="button"
                className={styles.uploadRemove}
                onClick={removeBanner}
              >
                ×
              </button>
            </div>
          ) : null}
        </div>
      </div>

      <div className={styles.sectionLabel}>
        {t('sponsorPledgeFlow.step4.brandSection')}
      </div>
      <label className={styles.crLabel} htmlFor="sp-brand">
        {t('sponsorPledgeFlow.step4.brandMessage')}
        <span className={styles.optionalTag}>
          {t('sponsorPledgeFlow.optional')}
        </span>
      </label>
      <p style={{ fontSize: 13, color: 'var(--light)', marginBottom: 10 }}>
        {t('sponsorPledgeFlow.step4.brandMessageHint')}
      </p>
      <textarea
        id="sp-brand"
        className={styles.crTextarea}
        rows={2}
        maxLength={120}
        value={brandMessage}
        onChange={e => setBrandMessage(e.target.value)}
        placeholder={t('sponsorPledgeFlow.step4.brandPlaceholder')}
      />
      <div className={styles.charCount}>{brandMessage.length} / 120</div>

      <div className={styles.sectionLabel}>
        {t('sponsorPledgeFlow.step4.organizerSection')}
      </div>
      <label className={styles.crLabel} htmlFor="sp-org-msg">
        {t('sponsorPledgeFlow.step4.organizerMessage')}
      </label>
      <p style={{ fontSize: 14, color: 'var(--light)', marginBottom: 10 }}>
        {t('sponsorPledgeFlow.step4.organizerHint')}
      </p>
      <textarea
        id="sp-org-msg"
        className={styles.crTextarea}
        rows={5}
        maxLength={400}
        value={orgMessage}
        onChange={e => setOrgMessage(e.target.value)}
        placeholder={t('sponsorPledgeFlow.step4.organizerPlaceholder')}
      />
      <div className={styles.charCount}>{orgMessage.length} / 400</div>

      <div className={styles.stepNav}>
        <button
          type="button"
          className={styles.btnBack}
          onClick={() => setStep(3)}
        >
          ‹ {t('buttons.back')}
        </button>
        <button
          type="button"
          className={styles.btnPrimary}
          onClick={validateStep4}
        >
          {t('buttons.continue')}
          <Icon name="chevron-right" />
        </button>
      </div>
    </>
  )
}
